"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitMeasurement = function (measurement) {
    if (typeof measurement !== 'string') {
        return {
            unit: 'NA',
            value: 0,
        };
    }
    var _a = measurement.split('|'), value = _a[0], unit = _a[1];
    return {
        unit: unit,
        value: Number(value),
    };
};
